import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chat-message-body',
  templateUrl: './chat-message-body.component.html',
  styleUrls: ['./chat-message-body.component.scss']
})
export class ChatMessageBodyComponent {
  @Input() chat: any;
  @Output() imageLoad = new EventEmitter<void>();
  @Output() viewImage = new EventEmitter<string>();
  @Output() openLocation = new EventEmitter<any>();
  @Output() goToReply = new EventEmitter<any>();
}
